import { createFileRoute } from '@tanstack/react-router'
import type { LeavePrefill } from './-fields'
import { LeaveRequestEditor } from './-LeaveRequestEditor'

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/

// ModuleGuard is provided by the leave route.tsx layout.
export const Route = createFileRoute('/hr/leave/new')({
  // Vanaf het dagoverzicht van de urenregistratie komen de medewerker en de dag mee.
  validateSearch: (s: Record<string, unknown>): LeavePrefill => ({
    ...(typeof s.employeeId === 'string' && s.employeeId ? { employeeId: s.employeeId } : {}),
    ...(typeof s.date === 'string' && ISO_DATE.test(s.date) ? { date: s.date } : {}),
  }),
  component: NewLeaveRequestPage,
})

function NewLeaveRequestPage() {
  return <LeaveRequestEditor prefill={Route.useSearch()} />
}
